import { FormType } from 'Container/App/enum';
import { Actions } from './action';
import { LmsFormActions } from './enum';
import { LmsFormState, LmsOpener } from './interface';
import produce from 'immer';

export const initialState: LmsFormState = {
    lmsError: undefined,
    formData: {
        type: FormType.LMS,
        salutation: undefined,
        firstName: '',
        lastName: '',
        email: '',
    },
    responseData: undefined,
    openedBy: LmsOpener.RESULT_SCREEN,
};

const lmsReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case LmsFormActions.CHANGE_LMS_INPUT:
                draft.formData = {
                    ...state.formData,
                    ...action.payload,
                };
                break;
            case LmsFormActions.HANDLE_LMS_RESPONSE:
                draft.responseData = action.payload;
                break;
            case LmsFormActions.SET_LMS_OPENER:
                draft.openedBy = action.openedBy;
                break;
            case LmsFormActions.CLEAR_LMS_RESULT:
                draft.responseData = undefined;
                break;
        }
    });

export default lmsReducer;
